export const DRAWER_MIN_WIDTH = 500
export const DRAWER_MAX_WIDTH = 1000
export const DRAWER_DEFAULT_WIDTH = 720

export const clampDrawerWidth = (width: number): number =>
  Math.min(Math.max(width, DRAWER_MIN_WIDTH), DRAWER_MAX_WIDTH)
